

mainApp.component('dhcpSettings', {
    templateUrl: '/public/components/dhcpSettings.html',
    bindings: {
        model: '=',
        errors: "=",
        changeListener: '&'
    },
    controller: dhcpSettingsController
});


function dhcpSettingsController(GeneralUtilsService, $scope) {
    var ctrl = this;

    ctrl.$onInit = function() {
        ctrl.original = angular.copy(ctrl.model);
        ctrl.hasChanges = false;
        ctrl.tableDataModified = false;
    }

    ctrl.$doCheck = function() {
        if (!ctrl.changeListener)
            return;

        var isChangedNow = !angular.equals(ctrl.model, ctrl.original);

        // we only care when state is changed...
        if (ctrl.hasChanges === isChangedNow)
            return;

        ctrl.hasChanges = isChangedNow;
        ctrl.changeListener({isDirty: ctrl.hasChanges, componentName: 'dhcpSettings'});
    }

    $scope.$on('modelReloadedEvent', function (event, data) {
        ctrl.original = angular.copy(ctrl.model);
        ctrl.tableDataModified = new Date().getTime();
    });

    ctrl.reset = function() {
        ctrl.original = angular.copy(ctrl.model);
        ctrl.hasChanges = false;
        ctrl.tableDataModified = new Date().getTime();
    }

    ctrl.dhcpSettingsTableConfig = {
        id: "dhcpSettingsTableConfig",
        dataURL: function() {
            return null;
        },
        parseData: function() {
            return ctrl.model;
        },
        fields: [{
                label: "Description",
                noSort: false,
                style: "width: 25%",
                path: "description",
                template: "<span><input type='text' class='form-control' ng-model='item.description'/></span>"
            }, {
                label: "Option Number",
                noSort: false,
                style: "width: 10%",
                path: "tag",
                template: "<span><input type='number' min='0' class='form-control' ng-model='item.tag'/></span>"
            }, {
                label: "Type",
                noSort: false,
                style: "width: 15%",
                path: "optionType",
                template: "<span><select style='width: 100%' ng-change='tableConfig.typeChanged(item)' ng-options='o.key as o.label for o in tableConfig.optionTypes' ng-model='item.optionType'></select></span>"
            }, {
                label: "Data",
                noSort: false,
                style: "width: 50%",
                path: "value",
                template: "<span><input type='text' class='form-control' ng-model='item.value'/></span>"
            }],
        actions: [],
        addAction: function() {
            var newItem = {
                id: GeneralUtilsService.getRandomId(),
                name: '',
                tag: 0,
                optionType: '',
                value: ''
            };
            ctrl.model.push(newItem);
            ctrl.tableDataModified = new Date().getTime();
        },
        specialActions : [{
            func: function(selectedItems) {
                selectedItems.forEach(function(item) {
                    for (var i = 0 ; i < ctrl.model.length ; i++) {
                        var option = ctrl.model[i];
                        if (option.id === item.id) {
                            ctrl.model.splice(i, 1);
                            break;
                        }
                    }
                });
                ctrl.tableDataModified = new Date().getTime();
            },
            icon: "delete",
            tooltip: "Delete"
        }],
        selectedItems:[],
        optionTypes: [{
                key: 'dhcp_option_ascii',
                label: 'ASCII'
            }, {
                key: 'dhcp_option_hex',
                label: 'HEX'
            }, {
                key: 'dhcp_option_ip',
                label: 'IP'
            }],
        typeChanged: function(item) {
            item.value = '';
        },
        clientSideSort: true,
        clientSideSearch: true,
        clientSidePaging: true,
        titleSearch: true
    };
};

